import { useEffect } from "react"

const useEffectOnce = (callback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [])
}

export default useEffectOnce
